import {
  AppliedBundleDiscount,
  BundleDiscountWithBrand,
} from '@/services/api/bundle-discount'

import _ from 'lodash'

/**
 * まだバンドル割引が適用されていないカートアイテムに対して、適用可能なバンドル設定情報があれば、
 * それをリコメンデーション候補として選び出す。
 */
export function filterNotYetAppliedBundleDiscount(
  cartList: Cart[],
  appliedBundleDiscountList: AppliedBundleDiscount[],
  bundleDiscountList: BundleDiscountWithBrand[],
  enabledByBrandSpecification: EnabledByBrandSpecification
): BundleDiscountWithBrand[] {
  const fkuInCartList = cartList.map(cart => cart.fkuId)

  return bundleDiscountList
    .filter((discount) => {
      return !appliedBundleDiscountList.find(applied => applied.bundle_discount_id === discount.id) &&
        !_.isEmpty(_.intersection(discount.fku_ids, fkuInCartList))
    }).filter((discount) => {
      /**
       * behaviorによってリコメンデーション可能でないとされているブランドに対しては、一律で候補から除外する。
       */
      return enabledByBrandSpecification.enabled(discount.brand.brand_english_name)
    })
}

export interface Cart {
  id: string
  fkuId: string
}

export interface EnabledByBrandSpecification {
  enabled(brandEnglishName: string): boolean
}
